import { useContext } from 'react';
import { AddressContext } from '../contexts/AddressContext';
import { Calendar } from 'primereact/calendar';
import { AuthContext } from '../contexts/AuthContext';
import { ParameterContext } from '../contexts/ParameterContext';

export const TwinTab = ({ twin, formData, index, handleChange, onBlurTwins, onBlurValidate, errors }) => {
    const { twinsResidence } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);
    const { user } = useContext(AuthContext);

    console.log(user);

    const admOrDirText = parameters.nomParameters.find(x => x.param_name == 'ADM_REG').value;

    const checkTwinFields = () => {
        if (formData.twins[index].twinName && formData.twins[index].twinEgn && twinsResidence[index] && twinsResidence[index].length == 0) {
            return true;
        }

        return false
    }
    return (
        <div className="w-100 children_data fade p-3-mob">
            <p className="ptext mt-0">Близнак {index + 1} </p>
            <div className="w-100 d-flex gap-3 flex-col-mob">

                <div className="flex-col flex-wrap w-50 w-100-mob">
                    <div className="labels_rb" id="basic-addon1">
                        ЕГН*
                        <input
                            type="checkbox"
                            id={`egnid_${index}`}
                            name={`twinIsEgn`}
                            value="1"
                            checked={twin.twinIsEgn == '1'}
                            onChange={(e) => handleChange(e, index)}
                            defaultChecked

                        />
                        &nbsp;&nbsp;&nbsp;ЛНЧ*
                        <input
                            type="checkbox"
                            id={`lncid_${index}`}
                            name={`twinIsEgn`}
                            value="0"
                            checked={twin.twinIsEgn == '0'}
                            onChange={(e) => handleChange(e, index)}
                        />
                    </div>
                    <div className="labels_rb d-flex gap-2 w-100 flex-wrap" id="basic-addon1">
                        <input
                            type="text"
                            name={`twinEgn`}
                            className={`${ ((twinsResidence[index] && twinsResidence[index].length > 0) || (user.role === 'SuperAdmin' || user.role === 'Municipality' || user.role === 'Admin')) ? 'border border-success' : 'border border-danger'} form-control round_buttons`}
                            placeholder={twin.twinIsEgn == '1' ? 'ЕГН на близнак' : 'ЛНЧ на близнак'}
                            value={twin.twinEgn}
                            onChange={(e) => handleChange(e, index)}
                            onBlur={(e) => onBlurTwins(e, index)}
                        />
                        {formData.twins[index].twinIsEgn == 0 &&
                            <Calendar
                                showButtonBar
                                locale='bg'
                                className="fade prime-dropdown-heigth w-100"
                                name={`twinLncDate`}
                                value={formData.twins[index][`twinLncDate`] || null}
                                onChange={(e) => handleChange(e, index)}
                                showIcon
                                onBlur={onBlurValidate}
                                placeholder='Дата на раждане'
                                disabled={user.changeGrao ? false : true}
                            />
                        }
                    </div>
                </div>

                <div className="w-50 w-100-mob">
                    <div className="labels_rb w-100" id="basic-addon1">  ТРИ ИМЕНА*:</div>
                    <input
                        type="text w-100"
                        name={`twinName`}
                        className={`${((twinsResidence[index] && twinsResidence[index].length > 0) || (user.role === 'SuperAdmin' || user.role === 'Municipality' || user.role === 'Admin')) ? 'border border-success' : 'border border-danger'} form-control round_buttons`}
                        placeholder="Полето трябва да е изписано на кирилица"
                        value={twin.twinName}
                        onChange={(e) => handleChange(e, index)}
                        onBlur={(e) => onBlurTwins(e, index)}
                        maxLength={100}
                    />
                </div>
            </div>
            {errors[`${index}twinEgn`] && <label className="text-danger w-100 ">{errors[`${index}twinEgn`]}</label>}
            {errors[`${index}twinName`] && <label className="text-danger w-100 ">{errors[`${index}twinName`]}</label>}
            {checkTwinFields() && <label className="text-danger w-100 ">Няма намерени данни. Заявление можете да регистрирате на място в {admOrDirText}.</label>}
        </div>
    )
}